// extracted by mini-css-extract-plugin
export default {"coverImg":"Cover_coverImg__1sk+D"};